import { computed, Injectable, signal } from '@angular/core';

export const messageSource = [
  {
    title: 'Payment_Has_Been_Expired',
    subTitle: 'Payment_Has_Been_Expired_Sub',
    icon: 'assets/images/svgs/_link-expired.svg',
    alt: 'Expired',
    dbText: 'ამ ლინკს გაუვიდა მოქმედების ვადა',
    link:'expired',
  },

  {
    title: 'An_Error_Has_Been_Occurred',
    subTitle: 'An_Error_Has_Been_Occurred_Sub',
     icon: 'assets/images/svgs/_error.svg',   
    alt: 'Error',
    dbText: 'კლიენტის პერსონალური ინფორმაცია ვერ მოიძებნა',
    link:'not-found',
  },
  {
    title: 'Payment_Has_Been_Successfully_Processed',
    subTitle: '',
    icon: 'assets/images/svgs/_success.svg',   
    alt: 'Success',
    dbText: 'გადახდა წარმატებით დასრულდა',
    link:'/payment-result-success',
    backToHomeBtn:'Main_Page'
  },
  {
    title: 'The_Operation_Has_Been_Failed',
    subTitle: '',
    icon: 'assets/images/svgs/_fail.svg',   
    alt: 'Fail',
    dbText: 'ოპერაცია ვერ განხორციელდა',
    link:'/payment-result-fail',
    backToHomeBtn: 'Main_Page'
  },
  {
    title: 'Please_Confirm_Payment',
    subTitle: `Please_Confirm_Payment_Subtitle`,
    icon: 'assets/images/svgs/_pending.svg',   
    alt: 'Pending',
    dbText: 'გთხოვთ დაადასტუროთ გადახდა',
    link:'/payment-result-confirmation-pending',
    backToHomeBtn: 'Main_Page'
  }
]

export interface ErrorSource {
  title: string,
  subTitle: string,
  icon: string,
  alt:string,
  dbText?:string,
  link:string,
  payment?:string;
  backToHomeBtn?:string
}
@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

}
